import { type ControllerRenderProps, useController } from 'react-hook-form';
import type {
  InviteViaEmailFormReturn,
  InviteViaEmailFormValues,
} from '../inviteViaEmailForm.types';
import { DEFAULT_LOCALE } from '@doxyme/locale';
import { useFilterPreviousSelectedLanguages } from '../../useFilterPreviousSelectedLanguages';

export const useLanguageField = (
  form: InviteViaEmailFormReturn,
): ControllerRenderProps<InviteViaEmailFormValues, 'languageField'> => {
  const filteredPreviouslySelected = useFilterPreviousSelectedLanguages();

  return useController({
    name: 'languageField',
    defaultValue: filteredPreviouslySelected[0] ?? DEFAULT_LOCALE,
    control: form.control,
  }).field;
};
